export default __webpack_public_path__ + "static/media/org.2115f8fd.png";